var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExlamIconMidnightFill3X(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M17.473 9.346a8.709 8.709 0 10-17.417 0 8.709 8.709 0 0017.417 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#091B2B",
    d: "M8.774 13.364c.22 0 .407.082.554.247.15.164.223.375.223.635 0 .246-.074.45-.223.611a.72.72 0 01-.554.242.746.746 0 01-.57-.242.856.856 0 01-.226-.61c0-.253.077-.464.232-.631a.736.736 0 01.564-.252zm.56-1.26H8.213l-.245-7.746H9.58l-.245 7.745z"
  }))));
}
export default SvgExlamIconMidnightFill3X;